export const skillGroups = [
    {
        category: 'Cloud Platforms',
        items: [
            { title: 'AWS', img: '/assets/aws.png', url: 'https://docs.aws.amazon.com/' },
            { title: 'Azure', img: '/assets/azure.svg', url: 'https://learn.microsoft.com/en-us/azure/' },
            { title: 'GCP', img: '/assets/gcp.png', url: 'https://cloud.google.com/docs' },
        ],
    },
    {
        category: 'Containers & Orchestration',
        items: [
            { title: 'Kubernetes', img: '/assets/kubernetes.png', url: 'https://kubernetes.io/docs/home/' },
            { title: 'Docker', img: '/assets/docker.png', url: 'https://docs.docker.com' },
            { title: 'Helm', img: '/assets/helm.svg', url: 'https://helm.sh/' },
            { title: 'Istio', img: '/assets/istio.png', url: 'https://istio.io/' },
        ],
    },
    {
        category: 'IaC, GitOps & Secrets',
        items: [
            { title: 'Terraform', img: '/assets/terraform.png', url: 'https://developer.hashicorp.com/terraform/docs' },
            { title: 'Argo CD', img: '/assets/argocd.svg', url: 'https://argo-cd.readthedocs.io/' },
            { title: 'Packer', img: '/assets/packer.svg', url: 'https://developer.hashicorp.com/packer/docs' },
            { title: 'Vault', img: '/assets/vault.svg', url: 'https://developer.hashicorp.com/vault/docs' },
        ],
    },
    {
        category: 'CI/CD & Tooling',
        items: [
            { title: 'Jenkins', img: '/assets/jenkins.png', url: 'https://www.jenkins.io/' },
            { title: 'GitHub', img: '/assets/github.png', url: 'https://docs.github.com/en' },
            { title: 'CI/CD', img: '/assets/cicd.png', url: 'https://about.gitlab.com/topics/ci-cd/' },
            { title: 'Linux', img: '/assets/linux.png', url: 'https://docs.kernel.org' },
        ],
    },
    {
        category: 'Languages & Frameworks',
        items: [
            { title: 'Python', img: '/assets/python.png', url: 'https://www.python.org/doc/' },
            { title: 'Golang', img: '/assets/golang.png', url: 'https://go.dev/' },
            { title: 'Django', img: '/assets/django.png', url: 'https://docs.djangoproject.com/' },
        ],
    },
    {
        category: 'Data & Observability',
        items: [
            { title: 'Airflow', img: '/assets/airflow.png', url: 'https://airflow.apache.org/docs/' },
            { title: 'Kafka', img: '/assets/kafka.png', url: 'https://kafka.apache.org/' },
            { title: 'Postgres', img: '/assets/postgres.png', url: 'https://www.postgresql.org/docs/' },
            { title: 'MongoDB', img: '/assets/mongo.png', url: 'https://www.mongodb.com/docs/' },
            { title: 'ELK Stack', img: '/assets/elk.png', url: 'https://www.elastic.co/guide/index.html' },
        ],
    },
];
